(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaea7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaea7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5Ip5k", function(module, exports) {
"use strict";
var $42948526aa176599$var$__assign = module.exports && module.exports.__assign || function() {
    $42948526aa176599$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $42948526aa176599$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.factory = module.exports.date = module.exports.boolean = module.exports.string = module.exports.number = void 0;

var $i74Nn = parcelRequire("i74Nn");
function $42948526aa176599$var$number(input) {
    if (typeof input === 'string') input = input.replace(/,/, '.');
    return Number(input).valueOf() || 0;
}
module.exports.number = $42948526aa176599$var$number;
function $42948526aa176599$var$string(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    if (typeof input === 'number') return input + '';
    return '';
}
module.exports.string = $42948526aa176599$var$string;
function $42948526aa176599$var$boolean(input) {
    if (input && Array.isArray(input) && input.length === 0) return false;
    return !!input;
}
module.exports.boolean = $42948526aa176599$var$boolean;
function $42948526aa176599$var$date(input, returnNullOnError) {
    if (returnNullOnError === void 0) returnNullOnError = true;
    if (!input) return null;
    return $i74Nn.parseTime(input, returnNullOnError);
}
module.exports.date = $42948526aa176599$var$date;
function $42948526aa176599$var$factory(input, definitions) {
    if (!input || typeof input !== 'object') return Object.assign({}, definitions.default);
    var response = Object.assign({}, definitions.default);
    var clonedInput = Object.assign({}, definitions.default, input);
    if (definitions.from) {
        var keys = Object.keys(definitions.from);
        keys.forEach(function(key) {
            var value = definitions.from[key];
            if (typeof value === 'function') {
                var out = value(clonedInput);
                clonedInput[key] = out;
            } else {
                if (typeof clonedInput[value] !== 'undefined') clonedInput[key] = clonedInput[value];
                else if (definitions.default && typeof definitions.default[value] !== 'undefined') clonedInput[key] = definitions.default[value];
            }
        });
    }
    if (definitions.any) definitions.any.map(function(name) {
        response[name] = clonedInput[name];
    });
    if (definitions.number) definitions.number.map(function(name) {
        response[name] = $42948526aa176599$var$number(clonedInput[name]);
    });
    if (definitions.string) definitions.string.map(function(name) {
        response[name] = $42948526aa176599$var$string(clonedInput[name]);
    });
    if (definitions.boolean) definitions.boolean.map(function(name) {
        response[name] = $42948526aa176599$var$boolean(clonedInput[name]);
    });
    if (definitions.date) definitions.date.map(function(name) {
        response[name] = $42948526aa176599$var$date(clonedInput[name]);
    });
    if (definitions.object) {
        var keys = Object.keys(definitions.object);
        keys.map(function(key) {
            response[key] = $42948526aa176599$var$factory(clonedInput[key], definitions.object[key]);
        });
    }
    if (definitions.objects) {
        var keys = Object.keys(definitions.objects);
        keys.map(function(key) {
            if (typeof definitions.objects[key] !== 'object') throw new Error('objects[' + key + '] must be a object with definition!');
            var inputArray = clonedInput[key];
            if (!inputArray) inputArray = [];
            else if (!Array.isArray(inputArray)) throw new Error(key + ' is not an array.');
            response[key] = inputArray.map(function(inputOfItem) {
                return $42948526aa176599$var$factory(inputOfItem, definitions.objects[key]);
            }).filter(function(d) {
                return !!d;
            });
        });
    }
    if (definitions.objectMap) {
        var keys = Object.keys(definitions.objectMap);
        keys.map(function(key) {
            response[key] = {};
            if (clonedInput[key]) Object.keys(clonedInput[key]).map(function(itemKey) {
                response[key][itemKey] = definitions.objectMap[key](clonedInput[key][itemKey]);
            });
        });
    }
    if (definitions.subItem) {
        var keys = Object.keys(definitions.subItem);
        keys.map(function(key) {
            if (typeof definitions.subItem[key] !== 'function') throw new Error('subItem[' + key + '] must be a function!');
            response[key] = definitions.subItem[key](clonedInput[key]);
        });
    }
    if (definitions.subItems) {
        var keys = Object.keys(definitions.subItems);
        keys.map(function(key) {
            if (typeof definitions.subItems[key] !== 'function') throw new Error('subItems[' + key + '] must be a function!');
            var inputArray = clonedInput[key];
            if (!inputArray) inputArray = [];
            else if (!Array.isArray(inputArray)) throw new Error(key + ' is not an array.');
            response[key] = inputArray.map(function(v) {
                return definitions.subItems[key](v);
            });
        });
    }
    if (definitions.enum) {
        var keys = Object.keys(definitions.enum);
        keys.map(function(key) {
            var allowedValues = definitions.enum[key];
            if (!Array.isArray(allowedValues)) throw new Error('Not an array: definitions.enum[' + key + ']');
            if (allowedValues.indexOf(clonedInput[key]) === -1) {
                var foundAlternative = false;
                if (typeof clonedInput[key] === 'number') {
                    var stringVersion = $42948526aa176599$var$string(clonedInput[key]);
                    if (allowedValues.indexOf(stringVersion) !== -1) {
                        response[key] = stringVersion;
                        foundAlternative = true;
                    }
                } else if (typeof clonedInput[key] === 'string') {
                    var numericVersion = $42948526aa176599$var$number(clonedInput[key]);
                    if (allowedValues.indexOf(numericVersion) !== -1) {
                        response[key] = numericVersion;
                        foundAlternative = true;
                    }
                }
                if (!foundAlternative) {
                    if (definitions.default && typeof definitions.default[key] !== 'undefined') response[key] = definitions.default[key];
                    else response[key] = null;
                }
            } else response[key] = clonedInput[key];
        });
    }
    if (definitions.map) {
        var keys = Object.keys(definitions.map);
        keys.map(function(key) {
            if (!definitions.map[key] || typeof definitions.map[key] !== 'function') throw new Error('Not a function: definitions.map[' + key + ']');
            response[key] = definitions.map[key](response[key]);
        });
    }
    if (definitions.from) {
        var keys = Object.keys(definitions.from);
        keys.forEach(function(key) {
            if (typeof response[key] === 'undefined') response[key] = clonedInput[key];
        });
    }
    if (definitions.extends) response = $42948526aa176599$var$__assign($42948526aa176599$var$__assign({}, definitions.extends(clonedInput)), response);
    return response;
}
module.exports.factory = $42948526aa176599$var$factory;

});
parcelRegister("i74Nn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseTime = void 0;
function $d2fc99b5cd4135ac$var$parseTime(input, returnNullOnInvalid) {
    if (returnNullOnInvalid === void 0) returnNullOnInvalid = true;
    var date = new Date();
    if (typeof input === 'string') {
        var number = parseInt(input, 10);
        if (!isNaN(number) && number + '' === input) input = number;
    }
    switch(typeof input){
        case 'object':
            if (input instanceof Date) {
                date = input;
                break;
            }
            if (input.day && input.month && input.year) {
                date.setUTCFullYear(input.year, input.month - 1, input.day);
                date.setHours(0, 0, 0, 0);
                date.setTime(date.getTime() - date.getTimezoneOffset() * 60000);
                break;
            }
            if (returnNullOnInvalid) return null;
            throw new Error('Given input must be a Date, parsable string or a number timestamp.');
        case 'string':
            var stringInput = input;
            var alreadyCreatedDate = false;
            // mysql format
            var match = stringInput.trim().match(/^(\d{4})-(\d{2})-(\d{2})([\sT]+(\d{2}):(\d{2}):(\d{2}))?$/);
            if (match) {
                stringInput = match[2] + '/' + match[3] + '/' + match[1];
                if (match[4]) stringInput += ' ' + match[5] + ':' + match[6] + ':' + match[7];
            }
            // czech human format
            var matchHuman = stringInput.trim().match(/^(\d{1,2})\.\s?(\d{1,2})\.\s?(\d{2,4})(\s+(\d{1,2})[:.](\d{1,2})([:.](\d{1,2}))?)?$/);
            if (matchHuman) {
                alreadyCreatedDate = true;
                date = new Date(parseInt(matchHuman[3]), parseInt(matchHuman[2]) - 1, parseInt(matchHuman[1]), parseInt(matchHuman[5]) || 12, parseInt(matchHuman[6]) || 0, parseInt(matchHuman[8]) || 0);
            }
            if (!alreadyCreatedDate) date = new Date(stringInput);
            if (!date.getTime() || isNaN(date.getTime())) {
                if (returnNullOnInvalid) return null;
                throw new Error('Given input could not be parsed into a Date: ' + stringInput);
            }
            break;
        case 'number':
            var fixedInput = void 0;
            if (input < 2000000000) fixedInput = input * 1000;
            else fixedInput = input;
            date = new Date(fixedInput);
            if (!date.getTime() || isNaN(date.getTime())) {
                if (returnNullOnInvalid) return null;
                throw new Error('Given input could not be parsed into a Date: ' + input);
            }
    }
    if (!date.getTime() || isNaN(date.getTime())) {
        if (returnNullOnInvalid) return null;
        throw new Error('Given input could not be parsed into a Date.');
    }
    return date;
}
module.exports.parseTime = $d2fc99b5cd4135ac$var$parseTime;

});


parcelRegister("gwnVi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $c072311f5ee1335e$var$delay(t) {
    return new Promise(function(resolve, reject) {
        setTimeout(function() {
            resolve();
        }, t);
    });
}
module.exports.delay = $c072311f5ee1335e$var$delay;

});

parcelRegister("kQsQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatFileSize = void 0;
var $f2cf08f37be65ab8$var$units = [
    'B',
    'kB',
    'MB',
    'GB',
    'TB',
    'PB'
];
function $f2cf08f37be65ab8$var$formatFileSize(bytes) {
    var unit = 0;
    var bytesSize = bytes;
    var inverted = false;
    if (bytesSize < 0) {
        bytesSize *= -1;
        inverted = true;
    }
    while(bytesSize >= 1000){
        bytesSize /= 1000;
        unit++;
    }
    if (inverted) bytesSize *= -1;
    return Math.round(bytesSize) + ' ' + $f2cf08f37be65ab8$var$units[unit];
}
module.exports.formatFileSize = $f2cf08f37be65ab8$var$formatFileSize;

});

parcelRegister("2tyOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Languages = void 0;
var $1cd94b6ee324134e$var$Languages;
(function(Languages) {
    Languages["CZECH"] = "cs";
    Languages["ENGLISH"] = "en";
})($1cd94b6ee324134e$var$Languages = module.exports.Languages || (module.exports.Languages = {}));

});

parcelRegister("bnag1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nl2br = void 0;
function $8479cc9c39e4c00c$var$nl2br(input) {
    var output = input;
    output = output.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1<br />$2");
    return output;
}
module.exports.nl2br = $8479cc9c39e4c00c$var$nl2br;

});

parcelRegister("k6RGm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numberFormat = void 0;
function $03c7319611ca62fa$var$numberFormat(input, decimals, decPoint, thousandsSep) {
    if (decimals === void 0) decimals = 0;
    if (decPoint === void 0) decPoint = '.';
    if (thousandsSep === void 0) thousandsSep = '';
    if (typeof input === 'string') {
        input = parseFloat(input);
        if (isNaN(input)) input = 0;
    }
    var number = input + '';
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = thousandsSep;
    var dec = decPoint;
    var s = [];
    var toFixedFix = function(num, precision) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(num * k) / k).toFixed(precision);
    };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
module.exports.numberFormat = $03c7319611ca62fa$var$numberFormat;

});

parcelRegister("5hSjj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.processHours = module.exports.formatWeek = module.exports.formatDay = module.exports.formatInterval = module.exports.formatHour = module.exports.parseHour = module.exports.parseInterval = module.exports.parseDay = module.exports.parseWeek = module.exports.OpeningHoursStatus = void 0;
var $3d98ab36fd33407e$var$OpeningHoursStatus;
(function(OpeningHoursStatus) {
    OpeningHoursStatus[OpeningHoursStatus["CLOSED"] = 0] = "CLOSED";
    OpeningHoursStatus[OpeningHoursStatus["OPEN"] = 1] = "OPEN";
})($3d98ab36fd33407e$var$OpeningHoursStatus = module.exports.OpeningHoursStatus || (module.exports.OpeningHoursStatus = {}));
function $3d98ab36fd33407e$var$parseWeek(input, returnNullIfEmpty) {
    if (returnNullIfEmpty === void 0) returnNullIfEmpty = false;
    var r = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: []
    };
    if (Array.isArray(input) && !(input.length === 8 && !input[0] && (input[7] || input[7] === ''))) {
        for(var i = 6; i >= 0; i--)input[i + 1] = input[i];
        delete input[0];
    }
    var isAnything = false;
    for(var i = 1; i <= 7; i++){
        // @ts-ignore
        r[i] = $3d98ab36fd33407e$var$parseDay(input[i]);
        // @ts-ignore
        if (r[i].length > 0) isAnything = true;
    }
    if (!isAnything && returnNullIfEmpty) return null;
    return r;
}
module.exports.parseWeek = $3d98ab36fd33407e$var$parseWeek;
function $3d98ab36fd33407e$var$parseDay(input) {
    if (!input) return [];
    var intervals = input.split(/[,;]+/).filter(function(r) {
        return !!r;
    });
    var ints = intervals.map(function(i) {
        var r;
        try {
            r = $3d98ab36fd33407e$var$parseInterval(i);
            return r;
        } catch (e) {
            return null;
        }
    }).filter(function(r) {
        return !!r;
    });
    ints.sort(function(i1, i2) {
        return i1.open - i2.open;
    });
    ints = $3d98ab36fd33407e$var$filterIntervalsForOverlapping(ints);
    return ints;
}
module.exports.parseDay = $3d98ab36fd33407e$var$parseDay;
function $3d98ab36fd33407e$var$filterIntervalsForOverlapping(ints, recursiveFailsafe) {
    if (recursiveFailsafe === void 0) recursiveFailsafe = 0;
    if (recursiveFailsafe > 10) throw new Error('Could not resolve overlapping intervals: ' + JSON.stringify(ints));
    // Check for interlapping intervals and merge them if necessary
    var omitIntervalsWithTheseIndices = {};
    ints.forEach(function(thisInterval, index) {
        var nextInterval = ints[index + 1];
        if (!nextInterval) return;
        if (omitIntervalsWithTheseIndices[index]) return;
        // Intervals are adjacent - we just merge them
        if (thisInterval.close === nextInterval.open) {
            thisInterval.close = nextInterval.close;
            omitIntervalsWithTheseIndices[index + 1] = true;
            return;
        }
        // Next is contained inside this one - we just omit the inner one
        if (thisInterval.open <= nextInterval.open && thisInterval.close >= nextInterval.close) {
            omitIntervalsWithTheseIndices[index + 1] = true;
            return;
        }
        // Next is extending this one - we move ending time to the latter one
        if (nextInterval.open <= thisInterval.close && nextInterval.close >= thisInterval.close) {
            thisInterval.close = nextInterval.close;
            omitIntervalsWithTheseIndices[index + 1] = true;
            return;
        }
    });
    // if (Object.keys(omitIntervalsWithTheseIndices).length > 0) {
    // 	console.log('This failed check: ', ints, omitIntervalsWithTheseIndices);
    // }
    ints = ints.filter(function(interval, index) {
        return !omitIntervalsWithTheseIndices[index];
    });
    if (Object.keys(omitIntervalsWithTheseIndices).length > 0) ints = $3d98ab36fd33407e$var$filterIntervalsForOverlapping(ints, recursiveFailsafe + 1);
    return ints;
}
function $3d98ab36fd33407e$var$parseInterval(input) {
    if (!input) return null;
    var parts = input.trim().split(/[\s-]+/).filter(function(r) {
        return !!r;
    });
    if (parts.length === 2) {
        var p = {
            open: $3d98ab36fd33407e$var$parseHour(parts[0]),
            close: $3d98ab36fd33407e$var$parseHour(parts[1])
        };
        if (p.open === p.close) throw new Error('Interval is meaningless - ' + input);
        if (p.open > p.close) p.close += 24;
        return p;
    }
    throw new Error('Can not parse interval: ' + input);
}
module.exports.parseInterval = $3d98ab36fd33407e$var$parseInterval;
function $3d98ab36fd33407e$var$parseHour(input) {
    var parts = input.trim().split(/[:\.]+/).filter(function(r) {
        return !!r;
    });
    if (parts.length === 2) {
        var hour = $3d98ab36fd33407e$var$clamp(parseInt(parts[0], 10), 0, 24);
        var minute = $3d98ab36fd33407e$var$clamp(parseInt(parts[1], 10), 0, 60);
        if (isNaN(hour) || isNaN(minute)) throw new Error('Can not parse hour');
        if (minute >= 60) {
            minute = 0;
            hour++;
        }
        if (hour === 24) minute = 0;
        return hour + minute / 60;
    }
    if (parts.length === 1) {
        var t = parseInt(parts[0], 10);
        if (isNaN(t)) throw new Error('Can not parse hour: ' + input);
        return $3d98ab36fd33407e$var$clamp(t, 0, 24);
    }
    throw new Error('Can not parse hour: ' + input);
}
module.exports.parseHour = $3d98ab36fd33407e$var$parseHour;
function $3d98ab36fd33407e$var$formatHour(input) {
    var fixedInput = input;
    if (fixedInput > 24) fixedInput -= 24;
    if (fixedInput > 24) throw new Error('Invalid input time - ' + input);
    var hour = Math.floor(fixedInput);
    var hourString = hour + '';
    if (hour < 10) {
        if (!hour) hourString = '00';
        else hourString = '0' + hourString;
    }
    var minutes = Math.round((fixedInput - hour) * 60);
    var minutesString = minutes + '';
    if (minutes < 10) {
        if (!minutes) minutesString = '00';
        else minutesString = '0' + minutesString;
    }
    return hourString + ':' + minutesString;
}
module.exports.formatHour = $3d98ab36fd33407e$var$formatHour;
function $3d98ab36fd33407e$var$formatInterval(input) {
    return $3d98ab36fd33407e$var$formatHour(input.open) + ' - ' + $3d98ab36fd33407e$var$formatHour(input.close);
}
module.exports.formatInterval = $3d98ab36fd33407e$var$formatInterval;
function $3d98ab36fd33407e$var$formatDay(input) {
    return input.map(function(r) {
        return $3d98ab36fd33407e$var$formatInterval(r);
    }).join(', ');
}
module.exports.formatDay = $3d98ab36fd33407e$var$formatDay;
function $3d98ab36fd33407e$var$formatWeek(input, now) {
    if (now === void 0) now = null;
    if (!now) now = new Date();
    var day = now.getDay();
    if (!day) day = 7;
    var result = [];
    var currentRow = null;
    for(var i = 1; i <= 7; i++){
        // @ts-ignore
        var theDay = input[i];
        var thisDayFormatted = $3d98ab36fd33407e$var$formatDay(theDay);
        if (!currentRow || thisDayFormatted !== currentRow.hours) {
            if (currentRow) result.push(currentRow);
            currentRow = {
                dayFrom: i,
                dayTo: i,
                isSingleDay: true,
                hours: thisDayFormatted,
                isCurrent: false,
                isOpen: !!thisDayFormatted
            };
        } else if (currentRow) {
            currentRow.isSingleDay = false;
            currentRow.dayTo = i;
        }
    }
    if (currentRow) result.push(currentRow);
    result.map(function(row) {
        if (row.dayFrom <= day && row.dayTo >= day) row.isCurrent = true;
    });
    return result;
}
module.exports.formatWeek = $3d98ab36fd33407e$var$formatWeek;
function $3d98ab36fd33407e$var$processHours(hours, now) {
    if (now === void 0) now = null;
    if (!now) now = new Date();
    var day = now.getDay();
    if (!day) day = 7;
    // @ts-ignore
    var todayRules = hours[day];
    // @ts-ignore
    var yesterdayRules = day === 1 ? hours[7] : hours[day - 1];
    var thisTime = now.getHours() + now.getMinutes() / 60;
    var isOpen = false;
    var nextChange = null;
    var nextChangeDay = null;
    var nextChangeIsOpening = null;
    var nextChangeIsToday = false;
    var nextChangeIsTomorrow = false;
    // Standard scenario - today is just open or we open this day later
    for(var _i = 0, todayRules_1 = todayRules; _i < todayRules_1.length; _i++){
        var interval = todayRules_1[_i];
        if (interval.open <= thisTime && interval.close >= thisTime) {
            isOpen = true;
            nextChangeIsOpening = false;
            nextChange = interval.close;
            nextChangeDay = day;
            nextChangeIsToday = true;
        } else if (interval.open > thisTime) {
            if (nextChange === null) {
                nextChangeIsOpening = true;
                nextChange = interval.open;
                nextChangeIsToday = true;
                nextChangeDay = day;
            }
        }
    }
    // Special scenario - we opened yesterday and still are open
    if (yesterdayRules.length) {
        var thisTimeOverlapped = thisTime + 24;
        for(var _a = 0, yesterdayRules_1 = yesterdayRules; _a < yesterdayRules_1.length; _a++){
            var interval = yesterdayRules_1[_a];
            if (interval.open <= thisTimeOverlapped && interval.close >= thisTimeOverlapped) {
                isOpen = true;
                nextChangeIsOpening = false;
                nextChange = interval.close - 24;
                nextChangeDay = day;
                nextChangeIsToday = true;
            }
        }
    }
    // Special scenario - we are open and we close tomorrow
    if (nextChange && nextChange > 24) {
        nextChange -= 24;
        if (!nextChangeDay) nextChangeDay = 0;
        nextChangeDay += 1;
        nextChangeIsToday = false;
        nextChangeIsTomorrow = true;
        if (nextChangeDay > 7) nextChangeDay -= 7;
    }
    // Standard scenario - we open tomorrow or some later day
    if (nextChange === null) {
        var followingDays = [];
        var tomorrow = day + 1;
        if (tomorrow >= 8) tomorrow = 1;
        for(var i = day + 1; i <= 7; i++)followingDays.push(i);
        for(var i = 1; i < day; i++)followingDays.push(i);
        for(var _b = 0, followingDays_1 = followingDays; _b < followingDays_1.length; _b++){
            var nextDay = followingDays_1[_b];
            if (nextChange !== null) break;
            // @ts-ignore
            for(var _c = 0, _d = hours[nextDay]; _c < _d.length; _c++){
                var interval = _d[_c];
                if (nextChange !== null) break;
                if (interval.open) {
                    nextChange = interval.open;
                    nextChangeIsOpening = true;
                    nextChangeIsTomorrow = nextDay === tomorrow;
                    nextChangeDay = nextDay;
                }
            }
        }
    }
    return {
        currentStatus: isOpen ? $3d98ab36fd33407e$var$OpeningHoursStatus.OPEN : $3d98ab36fd33407e$var$OpeningHoursStatus.CLOSED,
        nextStatus: nextChangeIsOpening ? $3d98ab36fd33407e$var$OpeningHoursStatus.OPEN : $3d98ab36fd33407e$var$OpeningHoursStatus.CLOSED,
        nextChangeDay: nextChangeDay,
        nextChangeTime: nextChange,
        nextChangeIsToday: nextChangeIsToday,
        nextChangeIsTomorrow: nextChangeIsTomorrow
    };
}
module.exports.processHours = $3d98ab36fd33407e$var$processHours;
function $3d98ab36fd33407e$var$clamp(n, low, high) {
    if (n < low) return low;
    if (n > high) return high;
    return n;
}

});

parcelRegister("4fsEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.paginatorSequence = void 0;

var $6nwbO = parcelRequire("6nwbO");
function $317ec9553755b4ec$var$paginatorSequence(totalPages, currentPage, preferredNumberOfLinks, addSeparators) {
    if (addSeparators === void 0) addSeparators = true;
    if (preferredNumberOfLinks < 5) throw new Error('preferredNumberOfLinks must be >= 5');
    if (totalPages <= preferredNumberOfLinks) return $6nwbO.range(1, totalPages);
    var output = new Set();
    var lastAdded = 0;
    var minPage = 1;
    output.add(currentPage);
    if (currentPage !== totalPages) output.add(currentPage + 1);
    if (currentPage > 1) output.add(currentPage - 1);
    output.add(totalPages);
    output.add(1);
    var i = 2;
    while(output.size < preferredNumberOfLinks){
        if (currentPage + i < totalPages) output.add(currentPage + i);
        if (output.size >= preferredNumberOfLinks) break;
        if (currentPage - i > 1) output.add(currentPage - i);
        if (output.size >= preferredNumberOfLinks) break;
        if (i % 2 === 0) {
            var stepFromExtreme = Math.floor(i / 2);
            output.add(stepFromExtreme + 1);
            if (output.size >= preferredNumberOfLinks) break;
            output.add(totalPages - stepFromExtreme);
            if (output.size >= preferredNumberOfLinks) break;
        }
        i++;
    }
    var numbers = Array.from(output);
    numbers.sort(function(a, b) {
        return a - b;
    });
    var outputNumbers = [];
    if (addSeparators) {
        var prev = 0;
        for(var _i = 0, numbers_1 = numbers; _i < numbers_1.length; _i++){
            var num = numbers_1[_i];
            if (num - 1 !== prev) outputNumbers.push(null);
            outputNumbers.push(num);
            prev = num;
        }
    } else outputNumbers = numbers;
    return outputNumbers;
}
module.exports.paginatorSequence = $317ec9553755b4ec$var$paginatorSequence;

});
parcelRegister("6nwbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.range = void 0;
function $4a4ddc3e016bc140$var$range(from, to, step) {
    if (step === void 0) step = 1;
    if (to === undefined) {
        to = from - 1;
        from = 0;
        step = 1;
    }
    if (from > to) throw new Error('[from] must be less than [to]');
    var count = Math.floor((to - from) / step);
    var a = Array(count);
    for(var i = from, index = 0; i <= to; i += step, index++)a[index] = i;
    return a;
}
module.exports.range = $4a4ddc3e016bc140$var$range;

});


parcelRegister("6I6mQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.phoneNumberFormatter = void 0;
function $4e2bca945d1a4d00$var$phoneNumberFormatter(input, international, spaces, internationalPrefix, defaultInternational) {
    if (international === void 0) international = true;
    if (spaces === void 0) spaces = '';
    if (internationalPrefix === void 0) internationalPrefix = '+';
    if (defaultInternational === void 0) defaultInternational = '420';
    if (!input) return '';
    var filteredInput = input.replace(/\D/g, '');
    var parsedInternational = '';
    var parsedMain = '';
    if (filteredInput.length > 9) {
        parsedInternational = filteredInput.substr(0, filteredInput.length - 9);
        parsedMain = filteredInput.substr(filteredInput.length - 9);
    } else parsedMain = filteredInput;
    if (internationalPrefix) {
        var escapedPrefix = internationalPrefix.replace(/([\[\\^$.|?*+()])/g, '\\$1');
        var regexpPrefix = new RegExp('^' + escapedPrefix, 'i');
        if (parsedInternational.match(regexpPrefix)) parsedInternational = parsedInternational.substr(internationalPrefix.length);
    }
    var spacedMain = '';
    if (spaces) {
        var len = parsedMain.length;
        for(var i = len; i > -3; i -= 3)spacedMain = parsedMain.substr(i >= 0 ? i : 0, i >= 0 ? 3 : 3 - i * -1) + (spacedMain ? spaces + spacedMain : '');
    } else spacedMain = parsedMain;
    var output = '';
    if (international) {
        if (!parsedInternational) parsedInternational = defaultInternational;
        output += internationalPrefix + parsedInternational;
        if (spaces) output += spaces;
    }
    output += spacedMain;
    return output;
}
module.exports.phoneNumberFormatter = $4e2bca945d1a4d00$var$phoneNumberFormatter;

});

parcelRegister("2D0YP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pluralize = void 0;
/**
 * Generate string using czech pluralization rules.
 *
 * Can be called also as pluralize(number, [one, two, five], symbol);
 *
 * @param {number} number
 * @param {string} one
 * @param {string} two
 * @param {string} five
 * @param {string} symbol
 * @return {string}
 */ function $1e9ffbf0e849504e$var$pluralize(number, one, two, five, symbol) {
    if (two === void 0) two = '';
    if (five === void 0) five = '';
    if (symbol === void 0) symbol = '%%';
    if (one && typeof one === 'object' && one.length) {
        symbol = two;
        if (!symbol) symbol = '%%';
        two = one[1] ? one[1] : one[0];
        five = one[2] ? one[2] : two;
        one = one[0];
    }
    var oneAsString = one;
    if (!two) two = oneAsString;
    if (!five) five = two;
    if (number > 0 && number <= 1) return oneAsString.replace(symbol, number + '');
    if (number > 1 && number <= 4) return two.replace(symbol, number + '');
    if (number >= -4 && number < -1) return two.replace(symbol, number + '');
    if (number >= -1 && number < 0) return oneAsString.replace(symbol, number + '');
    return five.replace(symbol, number + '');
}
module.exports.pluralize = $1e9ffbf0e849504e$var$pluralize;

});

parcelRegister("3MtLo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateRandomIdentifier = void 0;
function $2c0cf1294d2d6769$var$generateRandomIdentifier(length) {
    if (length === void 0) length = 8;
    if (length === 0) return '';
    if (length < 0 || typeof length !== 'number') throw new Error('Length must be positive integer');
    if (length <= 10) return Math.random().toString(36).substr(2, length).toLowerCase();
    return $2c0cf1294d2d6769$var$generateRandomIdentifier(10) + $2c0cf1294d2d6769$var$generateRandomIdentifier(length - 10);
}
module.exports.generateRandomIdentifier = $2c0cf1294d2d6769$var$generateRandomIdentifier;

});

parcelRegister("eMltV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.relativeTime = void 0;

var $2tyOu = parcelRequire("2tyOu");

var $awwdV = parcelRequire("awwdV");

var $2D0YP = parcelRequire("2D0YP");

var $i74Nn = parcelRequire("i74Nn");
function $ac26363654438522$var$relativeTime(input, language, now) {
    if (language === void 0) language = $2tyOu.Languages.CZECH;
    if (now === void 0) now = null;
    var date = $i74Nn.parseTime(input);
    if (!date) return '';
    var thatTime = date.getTime();
    if (!now) now = new Date();
    var diff = now.getTime() - thatTime;
    // Budoucí datum - asi jen omylem, zaokrouhlíme na 0
    if (diff < 0 && diff > -100) diff = 0;
    // Future dates support
    if (diff < 0) {
        if (diff > -5000) return $awwdV.Words.now[language];
        if (diff > -60000) return $awwdV.Words.momentLater[language];
        if (diff > -3600000) {
            var minutes = -1 * Math.round(diff / 60000);
            return $2D0YP.pluralize(minutes, $awwdV.Words.minutesLater[language]);
        }
        if (diff > -18000000) {
            var hours = -1 * Math.round(diff / 3600000);
            return $2D0YP.pluralize(hours, $awwdV.Words.hoursLater[language]);
        }
        if (diff > -82800000) {
            var tomorrow = '';
            if (date.getDay() === now.getDay() + 1 || now.getDay() === 6 && date.getDay() === 0) tomorrow = $awwdV.Words.tomorrowAt[language] + ' ';
            else tomorrow = $awwdV.Words.todayAt[language] + ' ';
            return tomorrow + $ac26363654438522$var$formatTimeOfDay(date);
        }
        // tento rok
        if (now.getFullYear() === date.getFullYear()) {
            if (language === $2tyOu.Languages.CZECH) // @ts-ignore
            return date.getDate() + '. ' + $awwdV.Months.namesGenitive[language][date.getMonth() + 1];
            else // @ts-ignore
            return $awwdV.Months.names[language][date.getMonth() + 1] + ' ' + date.getDate();
        }
        // ještě později
        if (language === $2tyOu.Languages.CZECH) // @ts-ignore
        return date.getDate() + '. ' + $awwdV.Months.namesGenitive[language][date.getMonth() + 1] + ' ' + date.getFullYear();
        else // @ts-ignore
        return $awwdV.Months.names[language][date.getMonth() + 1] + ' ' + date.getDate() + ', ' + date.getFullYear();
    }
    // Before now dates
    // Do 5 sekund
    if (diff < 5) return $awwdV.Words.now[language];
    // do 1 minuty
    if (diff < 60000) return $awwdV.Words.momentAgo[language];
    // do 1 hodiny
    if (diff < 3600000) {
        var minutes = Math.round(diff / 60000);
        return $2D0YP.pluralize(minutes, $awwdV.Words.minutesAgo[language]);
    }
    // do 10 hodin
    if (diff < 36000000) {
        var hours = Math.round(diff / 3600000);
        return $2D0YP.pluralize(hours, $awwdV.Words.hoursAgo[language]);
    }
    // do 24 hodin
    if (diff < 86400000) {
        var yesterdayText = '';
        if (date.getDay() === now.getDay() - 1) yesterdayText = $awwdV.Words.yesterdayAt[language] + ' ';
        return yesterdayText + $ac26363654438522$var$formatTimeOfDay(date);
    }
    // do 6 dnů
    if (diff < 518400000) {
        var yesterdayText = '';
        if (date.getDay() === now.getDay() - 1) yesterdayText = $awwdV.Words.yesterdayAt[language] + ' ';
        if (date.getDay() === 6 && now.getDay() === 0) yesterdayText = $awwdV.Words.yesterdayAt[language] + ' ';
        if (!yesterdayText) {
            var dayInWeek = date.getDay();
            // @ts-ignore
            yesterdayText = $awwdV.Days.localAt[language][dayInWeek] + ' ';
        }
        return yesterdayText + $ac26363654438522$var$formatTimeOfDay(date);
    }
    var yearStart = new Date();
    yearStart.setTime(now.getTime());
    yearStart.setDate(1);
    yearStart.setMonth(1);
    // tento rok
    if (yearStart.getFullYear() === date.getFullYear()) {
        if (language === $2tyOu.Languages.CZECH) // @ts-ignore
        return date.getDate() + '. ' + $awwdV.Months.namesGenitive[language][date.getMonth() + 1];
        else // @ts-ignore
        return $awwdV.Months.names[language][date.getMonth() + 1] + ' ' + date.getDate();
    }
    // ještě dříve
    if (language === $2tyOu.Languages.CZECH) // @ts-ignore
    return date.getDate() + '. ' + $awwdV.Months.namesGenitive[language][date.getMonth() + 1] + ' ' + date.getFullYear();
    else // @ts-ignore
    return $awwdV.Months.names[language][date.getMonth() + 1] + ' ' + date.getDate() + ', ' + date.getFullYear();
}
module.exports.relativeTime = $ac26363654438522$var$relativeTime;
function $ac26363654438522$var$formatTimeOfDay(date) {
    var m = date.getMinutes() + '';
    if (m.length === 1) m = '0' + m;
    var h = date.getHours() + '';
    // if (h.length === 1) {
    // 	h = '0' + h;
    // }
    return h + ':' + m;
}

});
parcelRegister("awwdV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Words = module.exports.Days = module.exports.Months = void 0;
var $7a95e37ecccd1f58$var$Months = /** @class */ function() {
    function Months() {}
    Months.names = {
        'cs': {
            1: 'Leden',
            2: "\xdanor",
            3: "B\u0159ezen",
            4: 'Duben',
            5: "Kv\u011Bten",
            6: "\u010Cerven",
            7: "\u010Cervenec",
            8: 'Srpen',
            9: "Z\xe1\u0159\xed",
            10: "\u0158\xedjen",
            11: 'Listopad',
            12: 'Prosinec'
        },
        'en': {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December'
        },
        'de': {
            1: 'Januar',
            2: 'Februar',
            3: "M\xe4rz",
            4: 'April',
            5: 'Mai',
            6: 'Juni',
            7: 'Juli',
            8: 'August',
            9: 'September',
            10: 'Oktober',
            11: 'November',
            12: 'Dezember'
        }
    };
    Months.namesGenitive = {
        'cs': {
            1: 'ledna',
            2: "\xfanora",
            3: "b\u0159ezna",
            4: 'dubna',
            5: "kv\u011Btna",
            6: "\u010Dervna",
            7: "\u010Dervence",
            8: 'srpna',
            9: "z\xe1\u0159\xed",
            10: "\u0159\xedjna",
            11: 'listopadu',
            12: 'prosince'
        },
        'en': {
            1: 'january',
            2: 'february',
            3: 'march',
            4: 'april',
            5: 'may',
            6: 'june',
            7: 'july',
            8: 'august',
            9: 'september',
            10: 'october',
            11: 'november',
            12: 'december'
        },
        'de': {
            1: 'januar',
            2: 'februar',
            3: "m\xe4rz",
            4: 'april',
            5: 'mai',
            6: 'juni',
            7: 'juli',
            8: 'august',
            9: 'september',
            10: 'oktober',
            11: 'november',
            12: 'dezember'
        }
    };
    Months.short = {
        'cs': {
            1: 'Led',
            2: "\xdano",
            3: "B\u0159e",
            4: 'Dub',
            5: "Kv\u011B",
            6: "\u010Crn",
            7: "\u010Crc",
            8: 'Srp',
            9: "Z\xe1\u0159",
            10: "\u0158\xedj",
            11: 'Lis',
            12: 'Pro'
        },
        'en': {
            1: 'Jan',
            2: 'Feb',
            3: 'Mar',
            4: 'Apr',
            5: 'May',
            6: 'Jun',
            7: 'Jul',
            8: 'Aug',
            9: 'Sep',
            10: 'Oct',
            11: 'Nov',
            12: 'Dec'
        },
        'de': {
            1: 'Jan',
            2: 'Feb',
            3: "M\xe4r",
            4: 'Apr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Aug',
            9: 'Sep',
            10: 'Okt',
            11: 'Nov',
            12: 'Dez'
        }
    };
    return Months;
}();
module.exports.Months = $7a95e37ecccd1f58$var$Months;
var $7a95e37ecccd1f58$var$Days = /** @class */ function() {
    function Days() {}
    Days.names = {
        'cs': {
            1: "Pond\u011Bl\xed",
            2: "\xdater\xfd",
            3: "St\u0159eda",
            4: "\u010Ctvrtek",
            5: "P\xe1tek",
            6: 'Sobota',
            7: "Ned\u011Ble"
        },
        'en': {
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            7: 'Sunday'
        },
        'de': {
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Samstag',
            7: 'Sonntag'
        }
    };
    Days.short = {
        'cs': {
            1: 'Po',
            2: "\xdat",
            3: 'St',
            4: "\u010Ct",
            5: "P\xe1",
            6: 'So',
            7: 'Ne'
        },
        'en': {
            1: 'Mon',
            2: 'Tue',
            3: 'Wed',
            4: 'Thu',
            5: 'Fri',
            6: 'Sat',
            7: 'Sun'
        },
        'de': {
            1: 'Mo',
            2: 'Di',
            3: 'Mi',
            4: 'Do',
            5: 'Fr',
            6: 'Sa',
            7: 'So'
        }
    };
    Days.local = {
        'cs': {
            1: "v pond\u011Bl\xed",
            2: "v \xfater\xfd",
            3: "ve st\u0159edu",
            4: "ve \u010Dtvrtek",
            5: "v p\xe1tek",
            6: 'v sobotu',
            7: "v ned\u011Bli"
        },
        'en': {
            1: 'on Monday',
            2: 'on Tuesday',
            3: 'on Wednesday',
            4: 'on Thursday',
            5: 'on Friday',
            6: 'on Saturday',
            7: 'on Sunday'
        },
        'de': {
            1: 'am Montag',
            2: 'am Dienstag',
            3: 'am Mittwoch',
            4: 'am Donnerstag',
            5: 'am Freitag',
            6: 'am Samstag',
            7: 'am Sonntag'
        }
    };
    Days.localAt = {
        'cs': {
            1: "v pond\u011Bl\xed v",
            2: "v \xfater\xfd v",
            3: "ve st\u0159edu v",
            4: "ve \u010Dtvrtek v",
            5: "v p\xe1tek v",
            6: 'v sobotu v',
            7: "v ned\u011Bli v"
        },
        'en': {
            1: 'on Monday at',
            2: 'on Tuesday at',
            3: 'on Wednesday at',
            4: 'on Thursday at',
            5: 'on Friday at',
            6: 'on Saturday at',
            7: 'on Sunday at'
        },
        'de': {
            1: 'am Montag um',
            2: 'am Dienstag um',
            3: 'am Mittwoch um',
            4: 'am Donnerstag um',
            5: 'am Freitag um',
            6: 'am Samstag um',
            7: 'am Sonntag um'
        }
    };
    return Days;
}();
module.exports.Days = $7a95e37ecccd1f58$var$Days;
var $7a95e37ecccd1f58$var$Words = /** @class */ function() {
    function Words() {}
    Words.now = {
        'cs': "te\u010F",
        'en': 'now',
        'de': 'jetzt'
    };
    Words.momentAgo = {
        'cs': "p\u0159ed chv\xedl\xed",
        'en': 'a moment ago',
        'de': 'vor einem Moment'
    };
    Words.momentLater = {
        'cs': "za okam\u017Eik",
        'en': 'in a minute',
        'de': 'in einem Moment'
    };
    Words.minutesAgo = {
        'cs': [
            "p\u0159ed %% minutou",
            "p\u0159ed %% minutami",
            "p\u0159ed %% minutami"
        ],
        'en': [
            '%% minute ago',
            '%% minutes ago',
            '%% minutes ago'
        ],
        'de': [
            'vor %% Minute',
            'vor %% Minuten',
            'vor %% Minuten'
        ]
    };
    Words.minutesLater = {
        'cs': [
            'za %% minutu',
            'za %% minuty',
            'za %% minut'
        ],
        'en': [
            'in %% minute',
            'in %% minutes',
            'in %% minutes'
        ],
        'de': [
            'in %% Minute',
            'in %% Minuten',
            'in %% Minuten'
        ]
    };
    Words.hoursAgo = {
        'cs': [
            "p\u0159ed %% hodinou",
            "p\u0159ed %% hodinami",
            "p\u0159ed %% hodinami"
        ],
        'en': [
            '%% hour ago',
            '%% hours ago',
            '%% hours ago'
        ],
        'de': [
            'vor %% Stunde',
            'vor %% Stunden',
            'vor %% Stunden'
        ]
    };
    Words.hoursLater = {
        'cs': [
            'za %% hodinu',
            'za %% hodiny',
            'za %% hodin'
        ],
        'en': [
            'in %% hour',
            'in %% hours',
            'in %% hours'
        ],
        'de': [
            'in %% Stunde',
            'in %% Stunden',
            'in %% Stunden'
        ]
    };
    Words.today = {
        'cs': 'dnes',
        'en': 'today',
        'de': 'heute'
    };
    Words.todayAt = {
        'cs': 'dnes v',
        'en': 'today at',
        'de': 'heute um'
    };
    Words.yesterday = {
        'cs': "v\u010Dera",
        'en': 'yesterday',
        'de': 'gestern'
    };
    Words.yesterdayAt = {
        'cs': "v\u010Dera v",
        'en': 'yesterday at',
        'de': 'gestern um'
    };
    Words.tomorrow = {
        'cs': "z\xedtra",
        'en': 'tomorrow',
        'de': 'morgen'
    };
    Words.tomorrowAt = {
        'cs': "z\xedtra v",
        'en': 'tomorrow at',
        'de': 'morgen um'
    };
    Words.afterTomorrow = {
        'cs': "poz\xedt\u0159\xed",
        'en': 'day after tomorrow',
        'de': "\xfcbermorgen"
    };
    Words.afterTomorrowAt = {
        'cs': "poz\xedt\u0159\xed v",
        'en': 'day after tomorrow at',
        'de': "\xfcbermorgen um"
    };
    return Words;
}();
module.exports.Words = $7a95e37ecccd1f58$var$Words;

});


parcelRegister("aQjmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shorten = void 0;
function $7e4dc69caf77748a$var$shorten(input, maxLength, wholeWords, addedString) {
    if (wholeWords === void 0) wholeWords = true;
    if (addedString === void 0) addedString = '';
    if (input.length <= maxLength) return input;
    if (!wholeWords) return input.substr(0, maxLength - addedString.length).trim() + addedString;
    var strippedPart = input.substr(0, maxLength - addedString.length + 1);
    var matches = strippedPart.match(/(.*)[\W]\w*$/);
    if (matches) return matches[1].trim() + addedString;
    else return $7e4dc69caf77748a$var$shorten(input, maxLength, false, addedString);
}
module.exports.shorten = $7e4dc69caf77748a$var$shorten;

});

parcelRegister("8dUdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.specChars = void 0;
var $5fcb269cd842266f$var$map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
};
function $5fcb269cd842266f$var$specChars(input) {
    return input.replace(/[&<>"']/g, // @ts-ignore
    function(m) {
        return $5fcb269cd842266f$var$map[m];
    });
}
module.exports.specChars = $5fcb269cd842266f$var$specChars;

});

parcelRegister("h0PsS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stripTags = void 0;
function $c62a5b93db4c1608$var$stripTags(input) {
    return input.replace(/<[a-z\/][^><]*>/ig, '');
}
module.exports.stripTags = $c62a5b93db4c1608$var$stripTags;

});

parcelRegister("5DBYN", function(module, exports) {
"use strict";
var $41ae0e3b65fd25f1$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUrlCreator = void 0;
function $41ae0e3b65fd25f1$var$createUrlCreator(params) {
    if (!params.urlBase || !params.urlBase.length) throw new Error('params.urlBase is required!');
    var idKeyName = params.idKeyName;
    var idKeyNameDefinite;
    var slugKeyName = params.slugKeyName;
    if (!idKeyName && idKeyName !== false) idKeyNameDefinite = 'id';
    else idKeyNameDefinite = idKeyName;
    if (!slugKeyName && slugKeyName !== false) slugKeyName = 'url';
    var startUrlWith = params.urlBase;
    if (typeof params.addFirstSlash === 'undefined' || params.addFirstSlash) {
        if (startUrlWith.length < 1 || startUrlWith[0][0] !== '/') startUrlWith[0] = '/' + startUrlWith[0];
    }
    // @ts-ignore
    return function(idOrObjectWithId, slug) {
        if (slug === void 0) slug = '';
        if (typeof idOrObjectWithId === 'object' && (idKeyNameDefinite !== false && idOrObjectWithId[idKeyNameDefinite] || idKeyNameDefinite === false)) {
            var theSlugValueAsStringOrArray = slugKeyName ? idOrObjectWithId[slugKeyName] || '' : '';
            var theSlugValue = void 0;
            if (Array.isArray(theSlugValueAsStringOrArray)) {
                if (params.firstSlugOnlyIfArray) theSlugValue = theSlugValueAsStringOrArray[0];
                else theSlugValue = theSlugValueAsStringOrArray.join('-');
            } else theSlugValue = theSlugValueAsStringOrArray;
            var theIdValue = idKeyNameDefinite ? idOrObjectWithId[idKeyNameDefinite] || '' : '';
            if (params.idKeyNameIfSlugIsMissing && !theSlugValue) theIdValue = idOrObjectWithId[params.idKeyNameIfSlugIsMissing] || '';
            if (theSlugValue || slug) {
                var slugValue = theSlugValue || slug;
                if (theIdValue) return $41ae0e3b65fd25f1$var$__spreadArray($41ae0e3b65fd25f1$var$__spreadArray([], startUrlWith), [
                    theIdValue,
                    slugValue
                ]);
                else return $41ae0e3b65fd25f1$var$__spreadArray($41ae0e3b65fd25f1$var$__spreadArray([], startUrlWith), [
                    slugValue
                ]);
            } else {
                if (theIdValue) return $41ae0e3b65fd25f1$var$__spreadArray($41ae0e3b65fd25f1$var$__spreadArray([], startUrlWith), [
                    theIdValue
                ]);
                else return $41ae0e3b65fd25f1$var$__spreadArray([], startUrlWith);
            }
        }
        if (typeof idOrObjectWithId === 'string') {
            if (slug) return $41ae0e3b65fd25f1$var$__spreadArray($41ae0e3b65fd25f1$var$__spreadArray([], startUrlWith), [
                idOrObjectWithId,
                slug
            ]);
            else return $41ae0e3b65fd25f1$var$__spreadArray($41ae0e3b65fd25f1$var$__spreadArray([], startUrlWith), [
                idOrObjectWithId
            ]);
        }
        throw new Error('Invalid parameters to create URL.');
    };
}
module.exports.createUrlCreator = $41ae0e3b65fd25f1$var$createUrlCreator;

});

parcelRegister("a8kiX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.technicalizeUrl = module.exports.humanizeUrl = void 0;
function $760a66d7ecd79c3c$var$humanizeUrl(input) {
    var matches = input.match(/^\s*(https?:\/\/)?([^\/]+)\/?(.*)\s*$/i);
    if (matches) {
        if (matches[2] && matches[2].length > 6) return matches[2];
        if (matches[3] || matches[2]) return matches[2] + '/' + matches[3];
    }
    return input;
}
module.exports.humanizeUrl = $760a66d7ecd79c3c$var$humanizeUrl;
function $760a66d7ecd79c3c$var$technicalizeUrl(input) {
    var matches = input.match(/^\s*(\w{3,15}:\/\/).*$/);
    if (matches) return input;
    return 'http://' + input;
}
module.exports.technicalizeUrl = $760a66d7ecd79c3c$var$technicalizeUrl;

});

parcelRegister("hyBcz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatWebAddress = void 0;
function $cc8278229d710614$var$formatWebAddress(input, mode, defaultScheme) {
    if (mode === void 0) mode = 'link';
    if (defaultScheme === void 0) defaultScheme = 'http';
    var domain = '';
    var scheme = '';
    var path = '';
    var match = input.match(/^\s*((\w{3,10}):\/\/)?([^\/]+)(\/(.*))?$/);
    if (match) {
        scheme = match[2] || '';
        domain = match[3] || '';
        path = match[5] || '';
        if (!scheme) scheme = defaultScheme;
        switch(mode){
            case 'link':
                return scheme + '://' + domain + '/' + path;
            case 'full':
                return domain + (path ? '/' + path : '');
            case 'short':
                return domain;
        }
    }
    return '';
}
module.exports.formatWebAddress = $cc8278229d710614$var$formatWebAddress;

});

parcelRegister("96ROt", function(module, exports) {
"use strict";
var $6a1e6abf58c6e705$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.samples = module.exports.sample = void 0;

var $k5fMy = parcelRequire("k5fMy");
function $6a1e6abf58c6e705$var$sample(inputArray) {
    return inputArray[Math.trunc(Math.random() * inputArray.length)];
}
module.exports.sample = $6a1e6abf58c6e705$var$sample;
function $6a1e6abf58c6e705$var$samples(inputArray, count) {
    var copy = $6a1e6abf58c6e705$var$__spreadArray([], inputArray);
    var copyShuffled = $k5fMy.default(copy);
    return copyShuffled.slice(0, count);
}
module.exports.samples = $6a1e6abf58c6e705$var$samples;

});
parcelRegister("k5fMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9f0844a5a7f0803$export$2e2bcd8739ae039; });
function $e9f0844a5a7f0803$export$2e2bcd8739ae039(array) {
    if (!Array.isArray(array)) throw new TypeError(`Expected an array, got ${typeof array}`);
    array = [
        ...array
    ];
    for(let index = array.length - 1; index > 0; index--){
        const newIndex = Math.floor(Math.random() * (index + 1));
        [array[index], array[newIndex]] = [
            array[newIndex],
            array[index]
        ];
    }
    return array;
}

});


parcelRegister("iB5Nv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateDistance = void 0;
function $d8a02df58160e414$var$toRadians(degrees) {
    return degrees / 180 * Math.PI;
}
/**
 * @param a
 * @param b
 * @return number Distance in meters
 */ function $d8a02df58160e414$var$calculateDistance(a, b) {
    if (!a || !b || typeof a.lat !== 'number' || typeof a.lng !== 'number' || typeof b.lat !== 'number' || typeof b.lng !== 'number') return NaN;
    var R = 6371e3;
    var lat1 = $d8a02df58160e414$var$toRadians(a.lat);
    var lat2 = $d8a02df58160e414$var$toRadians(b.lat);
    var deltaLat = lat2 - lat1;
    var deltaLng = $d8a02df58160e414$var$toRadians(b.lng - a.lng);
    var stepA = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(stepA), Math.sqrt(1 - stepA));
    return R * c;
}
module.exports.calculateDistance = $d8a02df58160e414$var$calculateDistance;

});

parcelRegister("bYuSj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arraySum = void 0;
function $8b7d3f756ad0b8c2$var$arraySum(arr) {
    if (!arr) return 0;
    return arr.filter(function(a) {
        return !!a;
    }).reduce(function(prev, curr) {
        return prev + curr;
    }, 0) || 0;
}
module.exports.arraySum = $8b7d3f756ad0b8c2$var$arraySum;

});

parcelRegister("7eYwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.$ = module.exports.onReady = void 0;
function $5458cae47fe800c6$var$onReady(fn) {
    if (typeof fn === 'string') {
        console.warn("This is not jQuery! Use $() function only for adding callbacks that should fire on page initialisation. Use $$() to search for an element.");
        return;
    }
    if (document.readyState === 'complete') fn();
    else document.addEventListener('DOMContentLoaded', fn);
}
module.exports.onReady = $5458cae47fe800c6$var$onReady;
module.exports.$ = $5458cae47fe800c6$var$onReady;

});

parcelRegister("10x2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.$$ = module.exports.findOnPage = void 0;
function $0bbf6c282e7ac51a$var$findOnPage(selector, parent) {
    if (!parent) parent = document;
    return parent.querySelector(selector);
}
module.exports.findOnPage = $0bbf6c282e7ac51a$var$findOnPage;
module.exports.$$ = $0bbf6c282e7ac51a$var$findOnPage;

});

// import { initHeader } from './header';
var $edd57b8217080095$exports = {};
"use strict";
var $edd57b8217080095$var$__createBinding = $edd57b8217080095$exports && $edd57b8217080095$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $edd57b8217080095$var$__exportStar = $edd57b8217080095$exports && $edd57b8217080095$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $edd57b8217080095$var$__createBinding(exports1, m, p);
};
Object.defineProperty($edd57b8217080095$exports, "__esModule", {
    value: true
});

$edd57b8217080095$var$__exportStar((parcelRequire("5Ip5k")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("gwnVi")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("kQsQ8")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("2tyOu")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("bnag1")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("k6RGm")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("5hSjj")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("4fsEk")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("i74Nn")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("6I6mQ")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("2D0YP")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("3MtLo")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("6nwbO")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("eMltV")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("aQjmc")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("8dUdY")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("h0PsS")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("awwdV")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("5DBYN")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("a8kiX")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("hyBcz")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("96ROt")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("iB5Nv")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("bYuSj")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("7eYwP")), $edd57b8217080095$exports);

$edd57b8217080095$var$__exportStar((parcelRequire("10x2I")), $edd57b8217080095$exports);


function $c9827539070a9f6b$export$e4b4358f24b41870(mainMenu) {
    let openers = mainMenu.querySelectorAll('[data-part="opener"]');
    let closer = mainMenu.querySelector('[data-part="closer"]');
    let menu = mainMenu.querySelector('[data-part="menu"]');
    openers?.forEach((opener1)=>{
        opener1.addEventListener('click', ()=>{
            if (menu) {
                if (menu.open) menu.close();
                else menu.show();
                mainMenu.classList.toggle('submenu-open', menu.open);
                if (menu.open) setTimeout(()=>{
                    menu.querySelector('a').focus();
                }, 100);
            }
        });
    });
    closer?.addEventListener('click', ()=>{
        if (menu) {
            menu.close();
            mainMenu.classList.remove('submenu-open');
            opener.focus();
        }
    });
    window.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && menu?.open) {
            menu.close();
            opener.focus();
            mainMenu.classList.remove('submenu-open');
        }
    });
}


function $1264c43a2924d85a$export$c068c49e556947aa(homehero) {
    let button1 = homehero.querySelector('[data-part="button1"]');
    if (button1) button1.addEventListener('click', (e)=>{
        e.preventDefault();
        if (window['OJNew']) window['OJNew'].showFreeCoursePopup();
    });
    let button2 = homehero.querySelector('[data-part="button2"]');
    if (button2) button2.addEventListener('click', (e)=>{
        e.preventDefault();
        let target = homehero.querySelector('[data-part="bottom"]');
        if (target) target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
    setTimeout(()=>{
        homehero.classList.remove('homehero--loading');
    }, 50);
}


let $56ad68ddd511b5ac$var$freeCoursePopupDialogElement;
let $56ad68ddd511b5ac$var$freeCoursePopupContentInitialised = false;
async function $56ad68ddd511b5ac$var$initPopupContent(dialog) {
    if ($56ad68ddd511b5ac$var$freeCoursePopupContentInitialised) {
        console.warn('Free course popup content already initialised');
        return;
    }
    $56ad68ddd511b5ac$var$freeCoursePopupContentInitialised = true;
    var form = {
        lang: null,
        course: null,
        step: 1
    };
    var submitting = false;
    let coursesJson = await fetch('new-design/demo-courses-list.json');
    let courses = {};
    if (coursesJson.ok) courses = await coursesJson.json();
    else return;
    var $selectLang = $('#demo-lang-select');
    var $selectCourse = $('#demo-course-select');
    $('#free-course-popup').find('.goto-step').click();
    form.lang = $selectLang.find('option').eq(0).val();
    function goToStep(step) {
        form.step = step;
        $('#free-course-popup').removeClass('demo-form--step1 demo-form--step2').addClass('demo-form--step' + step);
    }
    function rerenderSelectCourse() {
        form.lang = $selectLang.val();
        $selectCourse.html('');
        $.each(courses[form.lang], function(index, courseData) {
            $selectCourse.append($('<option></option>').val(courseData.id).text(courseData.name));
        });
        form.course = $selectCourse.find('option').eq(0).attr('value');
        $selectCourse.val(form.course);
        $('#demo-lang-icon').attr('src', $('#demo-lang-icon').attr('data-srcpattern').replace(/%lang%/, form.lang));
    }
    function updateSelectedCourse() {
        form.course = $selectCourse.val();
        $('#demo-course-cil').val(form.course);
    }
    function submit() {
        if (submitting) return false;
        submitting = true;
        var selectedCourse = courses[form.lang].find(function(c) {
            return +c.id === +form.course;
        });
        if (selectedCourse) {
            //dataLayer.push({event: 'Trial kurz', courseName: selectedCourse.name});
            // Nově pomocí GA4:
            if (dataLayer) {
                dataLayer.push({
                    "event": "demo",
                    course_id: selectedCourse.id + "",
                    course_name: selectedCourse.name
                });
                console.log(JSON.stringify(dataLayer));
            }
            // Affilbox
            window.ab_instance = "partneri.onlinejazyky.cz";
            window.ab_kampan = 11;
            window.ab_cena = 0;
            window.ab_id_transakce = $('#demo-course-form').find('input[name="email"]').val();
            console.log('Affilbox conversion code inserted', window.ab_kampan, window.ab_id_transakce);
            $(document.head).append('<script src="https://partneri.onlinejazyky.cz/c3.js" type="text/javascript"></script>');
        }
        setTimeout(function() {
            $('#demo-course-form').submit();
        }, 800);
    }
    $('#free-course-popup').find('.goto-step[data-step]').click(function() {
        goToStep($(this).attr('data-step'));
    });
    $selectLang.change(function() {
        form.lang = $selectLang.val();
        rerenderSelectCourse();
        updateSelectedCourse();
    });
    $('#demo-course-submit').click(function() {
        submit();
    });
    $selectCourse.change(function() {
        updateSelectedCourse();
    });
    goToStep(1);
    rerenderSelectCourse();
    updateSelectedCourse();
    setTimeout(function() {
        rerenderSelectCourse();
        updateSelectedCourse();
    }, 200);
}
function $56ad68ddd511b5ac$export$92c3700bdccd0e4f(dialog) {
    if ($56ad68ddd511b5ac$var$freeCoursePopupDialogElement) {
        console.warn('Free course popup already initialised');
        return;
    }
    let stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'css/homepage-demo-popup.css';
    document.head.appendChild(stylesheet);
    $56ad68ddd511b5ac$var$freeCoursePopupDialogElement = dialog;
    dialog.addEventListener('click', (e)=>{
        if (e.target && (e.target.nodeName === 'DIALOG' || e.target.matches('.free-course-popup__closer'))) dialog.close();
    });
}
async function $56ad68ddd511b5ac$export$75de5bb89d2e3b0e() {
    if ($56ad68ddd511b5ac$var$freeCoursePopupDialogElement) {
        if (!window['jQuery']) await new Promise((resolve)=>{
            let s = document.createElement('script');
            s.src = 'js/jquery-1.10.2.min.js';
            s.onload = resolve;
            document.head.appendChild(s);
        });
        if (!$56ad68ddd511b5ac$var$freeCoursePopupContentInitialised) $56ad68ddd511b5ac$var$initPopupContent($56ad68ddd511b5ac$var$freeCoursePopupDialogElement);
        $56ad68ddd511b5ac$var$freeCoursePopupDialogElement.showModal();
    }
} // var that = this;
 //
 // var $buttons = $("a[href='" + this.linkTestForFree + "']");
 //
 // if ($buttons.length) {
 // 	var $stylesheet = $('<link rel="stylesheet" type="text/css" href="css/homepage-demo-popup.css" />');
 // 	$(document.head).append($stylesheet);
 // }
 //
 // $buttons.each(function() {
 // 	var node = $(this);
 // 	//make sure it is not processed twice
 // 	if (node.data("oj-initialized")) {
 // 		return;
 // 	}
 // 	node.
 // 	data("oj-initialized", true);
 //
 // 	node
 // 		.attr("data-mfp-src", ".free-course-popup")
 // 		.click(function(e) {
 // 			//if (!that.isUserLogged()) {
 // 			e.preventDefault();
 // 			var n = $(this);
 // 			//create node on demand
 // 			that.createNodeTestForFree();
 // 			that.initHomepageDemoPopupForm();
 //
 // 			var processed = n.data("oj-processed");
 // 			//close menu
 // 			that.getMenu().close();
 //
 // 			if (!processed) {
 // 				n.magnificPopup({
 // 					type:'inline',
 // 					fixedContentPos: false,
 // 					midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
 // 					enableEscapeKey: true,
 // 					closeMarkup: '<button title="Zavřít [Esc]" class="mfp-close ico-close">&#xf00d;</button>',
 // 					mainClass: 'mfp-fade',
 // 					callbacks: {
 // 						open: function() {
 // 							$(".oj-page-header").css("display", "none");
 // 						},
 // 						close: function() {
 // 							// Will fire when popup is closed
 // 							$(".oj-page-header").css("display", "block");
 // 						}
 // 					}
 // 				});
 // 				n.data("oj-processed", true);
 // 				setTimeout(function() {
 // 					n.trigger("click");
 // 				}, 10);
 // 			}
 // 			//}
 // 		});
 // });


function $84aa1d732595f66d$export$bd3a03cd5b390fb5(main) {
    main.querySelectorAll('[data-part="start"]').forEach((d)=>{
        d.addEventListener('click', (e)=>{
            window['OJNew'].showFreeCoursePopup();
            e.preventDefault();
        });
    });
    let o = new IntersectionObserver((es)=>{
        es.forEach((e)=>{
            if (e.isIntersecting) {
                o.disconnect();
                run();
            }
        });
    }, {
        rootMargin: '-20% 0px -20% 0px'
    });
    o.observe(main);
    function run() {
        main.classList.remove('before');
        console.log('home-online run');
    }
}


function $3e7f1b186a1a9968$export$f53787fad777b87b(main) {
    main.querySelectorAll('[data-part="start"]').forEach((d)=>{
        d.addEventListener('click', (e)=>{
            window['OJNew'].showFreeCoursePopup();
            e.preventDefault();
        });
    });
}


/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $be6552333bc8d90d$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $be6552333bc8d90d$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $be6552333bc8d90d$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}


function $a740840dec315521$export$de9075bdfc9a7093(wrapper) {
    let slider = wrapper.querySelector('[data-part="slider"]');
    let next = wrapper.querySelector('[data-part="next"]');
    let prev = wrapper.querySelector('[data-part="prev"]');
    if (slider && next) {
        next.addEventListener('click', (e)=>{
            $a740840dec315521$var$scrollByStep(slider, 1);
        });
        prev.addEventListener('click', (e)=>{
            $a740840dec315521$var$scrollByStep(slider, -1);
        });
    }
    function adjustDisabledState() {
        let maxScroll = slider.scrollWidth - slider.clientWidth;
        let canScrollLeft = slider.scrollLeft > 0;
        let canScrollRight = slider.scrollLeft < maxScroll;
        if (prev) prev.disabled = !canScrollLeft;
        if (next) next.disabled = !canScrollRight;
    }
    slider.addEventListener('scroll', (0, $be6552333bc8d90d$export$de363e709c412c8a)(250, (e)=>{
        adjustDisabledState();
    }));
    adjustDisabledState();
}
function $a740840dec315521$var$scrollByStep(slider, step) {
    let length = 100;
    let measures = slider.querySelectorAll('[data-slide-measure]');
    if (measures.length > 1) {
        let pos1 = measures[0].offsetLeft;
        let pos2 = measures[1].offsetLeft;
        length = pos2 - pos1;
        if (length <= 100) length = 100;
    }
    slider.scrollBy({
        left: length * step,
        behavior: 'smooth'
    });
}


function $a71ce739b005a983$export$58b32dcf0e99eb77(main) {
    let obs = new IntersectionObserver((es)=>{
        es.forEach((e)=>{
            if (e.isIntersecting) {
                obs.disconnect();
                run();
            }
        });
    }, {
        rootMargin: '-20% 0px -20% 0px'
    });
    obs.observe(main);
    function run() {
        main.classList.remove('before');
    }
}


function $a8462e14bbea08a0$export$c9f495f2e0abee91(main) {
    let mainPart = main.querySelector('[data-part="main"]');
    let obs = new IntersectionObserver((es)=>{
        es.forEach((e)=>{
            if (e.isIntersecting) {
                obs.disconnect();
                run();
            }
        });
    }, {
        rootMargin: '-20% 0px -20% 0px'
    });
    if (mainPart) obs.observe(mainPart);
    function run() {
        main.classList.remove('before');
    }
}


function $1366a0a29fd5881d$export$aaf4f6ae80659af(main) {
    main.querySelectorAll('[data-part="button"]').forEach((d)=>{
        d.addEventListener('click', (e)=>{
            window['OJNew'].showFreeCoursePopup();
            e.preventDefault();
        });
    });
}


class $bff4f6cbfbfebeed$var$OJNew {
    constructor(){
        this.mainMenu = (0, $c9827539070a9f6b$export$e4b4358f24b41870);
        this.homehero = (0, $1264c43a2924d85a$export$c068c49e556947aa);
        this.freeCoursePopup = (0, $56ad68ddd511b5ac$export$92c3700bdccd0e4f);
        this.showFreeCoursePopup = (0, $56ad68ddd511b5ac$export$75de5bb89d2e3b0e);
        this.homeOnline = (0, $3e7f1b186a1a9968$export$f53787fad777b87b);
        this.homeMethod = (0, $84aa1d732595f66d$export$bd3a03cd5b390fb5);
        this.homeReferences = (0, $a740840dec315521$export$de9075bdfc9a7093);
        this.homeSelect = (0, $a71ce739b005a983$export$58b32dcf0e99eb77);
        this.homeFaces = (0, $a8462e14bbea08a0$export$c9f495f2e0abee91);
        this.homeFootButtons = (0, $1366a0a29fd5881d$export$aaf4f6ae80659af);
    }
}
window['OJNew'] = new $bff4f6cbfbfebeed$var$OJNew();
// @ts-ignore
window['$'] = (0, $edd57b8217080095$exports.onReady);
// @ts-ignore
window['$$'] = (0, $edd57b8217080095$exports.findOnPage);

})();
//# sourceMappingURL=index.js.map
